import { getAppConfig, hasFirebaseConfig, determineAppMode } from '@/config/appConfig.js';
import { AppMode } from '@k-ucap/shared';
import { firebaseApp } from './firebaseApp.js';
import { firebaseAuth } from './firebaseAuth.js';
import { firebaseFirestore } from './firebaseFirestore.js';
import { firebaseStorage } from './firebaseStorage.js';
import { firebaseFunctions } from './firebaseFunctions.js';

export interface FirebaseStatus {
  mode: AppMode;
  initialized: boolean;
  app: boolean;
  auth: boolean;
  firestore: boolean;
  storage: boolean;
  functions: boolean;
  projectId: string;
  region: string;
  error?: string;
}

export const getFirebaseStatus = (): FirebaseStatus => {
  const config = getAppConfig();
  const initialized = Boolean(firebaseApp && firebaseAuth && firebaseFirestore && firebaseStorage && firebaseFunctions);

  if (import.meta.env.VITE_FORCE_MOCK_MODE === 'true') {
    return {
      mode: AppMode.MOCK,
      initialized: false,
      app: false,
      auth: false,
      firestore: false,
      storage: false,
      functions: false,
      projectId: config.firebase.projectId || 'k-ucap',
      region: config.functionsRegion,
    };
  }

  const mode = determineAppMode(config, initialized, false);

  return {
    mode,
    initialized,
    app: Boolean(firebaseApp),
    auth: Boolean(firebaseAuth),
    firestore: Boolean(firebaseFirestore),
    storage: Boolean(firebaseStorage),
    functions: Boolean(firebaseFunctions),
    projectId: config.firebase.projectId || 'k-ucap',
    region: config.functionsRegion,
  };
};

export { AppMode, hasFirebaseConfig, determineAppMode };
